import React from 'react';
import { Tooltip } from 'antd';
import { AiFillStar } from 'react-icons/ai';
import './sky-inventory-badge.less';

interface Props {
  label: string;
  variant?: 'corner' | 'inline';
}

export const SkyInventoryBadge: React.FC<Props> = ({
  label,
  variant = 'corner',
}) => {
  if (variant === 'inline') {
    return (
      <Tooltip title={label}>
        <span className="sky-inventory-badge sky-inventory-badge--inline">
          <AiFillStar />
        </span>
      </Tooltip>
    );
  }

  return (
    <div className="sky-inventory-badge sky-inventory-badge--corner">
      <Tooltip title={label}>
        <span className="sky-inventory-badge__pill">
          <AiFillStar />
          <span className="sky-inventory-badge__pill-label">{label}</span>
        </span>
      </Tooltip>
      <span className="sky-inventory-badge__accent" aria-hidden="true">
        <StarIcon className="sky-inventory-badge__accent-star" />
      </span>
      <div className="curved-corner-absolute">
      <div className="curved-corner-relative-center ">
        <div className="curved-corner top" />
        <div className="curved-corner bottom" />
      </div>
      </div>
    </div>
  );
};

const StarIcon = ({
  size = 30,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  const glowFilterId = React.useId().replace(/:/g, '');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <filter id={glowFilterId} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
        </filter>
      </defs>

      <g className="sky-inventory-badge__accent-star-shape">
        <path
          d="M64 18
             L77 45
             L107 49
             L85 69
             L91 98
             L64 84
             L37 98
             L43 69
             L21 49
             L51 45
             Z"
          fill="#FFD87A"
          opacity="0.55"
          filter={`url(#${glowFilterId})`}
        />
        <path
          d="M64 20
             L76 45
             L104 49
             L84 68
             L89 95
             L64 82
             L39 95
             L44 68
             L24 49
             L52 45
             Z"
          fill="white"
          stroke="#F2C15B"
          strokeWidth="3.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
